var _rect, _path, _path2, _circle, _path3, _circle2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCooling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.8725,
    y: 14.762,
    width: 38.255,
    height: 25.4359,
    rx: 1,
    stroke: "#76A2D7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8994 41.1978H44.8348V42.6137C44.8348 43.166 44.3871 43.6137 43.8348 43.6137H38.8994C38.3471 43.6137 37.8994 43.166 37.8994 42.6137V41.1978Z",
    fill: "#76A2D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9014 41.1978H17.8367V42.6137C17.8367 43.166 17.389 43.6137 16.8367 43.6137H11.9014C11.3491 43.6137 10.9014 43.166 10.9014 42.6137V41.1978Z",
    fill: "#76A2D7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4797,
    cy: 27.2927,
    r: 8.8133,
    stroke: "#76A2D7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4954 22.6018L22.2014 24.8194L22.1782 24.9948L22.1781 24.9952L22.0459 25.993C21.8725 25.9173 21.681 25.8754 21.4797 25.8754C21.0528 25.8754 20.67 26.0641 20.4101 26.3627C20.2843 26.268 20.1659 26.1643 20.0559 26.0529C20.0454 26.0423 20.035 26.0316 20.0247 26.0208C19.8922 25.8829 19.7723 25.7334 19.6664 25.5743C19.251 24.9502 19.0514 24.1785 19.1576 23.3769C19.291 22.3709 19.877 21.536 20.6835 21.0502C21.2846 20.688 22.0082 20.5198 22.758 20.6191L22.7582 20.6191L22.7581 20.6196L22.4954 22.6018ZM20.0823 27.5309L19.2686 27.7185L18.985 27.7839L18.9218 27.7984L16.9164 28.2608L14.9675 28.7101L14.9676 28.7107C15.1377 29.4475 15.549 30.0659 16.0989 30.5018C16.8367 31.0866 17.8242 31.3426 18.813 31.1146C19.6582 30.9197 20.3477 30.4074 20.7846 29.7325C20.8588 29.6178 20.9257 29.4985 20.9848 29.3753C21.062 29.2145 21.1259 29.047 21.1756 28.8745C21.1934 28.8126 21.2094 28.7501 21.2235 28.687C20.6401 28.5805 20.1814 28.1168 20.0823 27.5309ZM22.3147 28.4382L22.8107 28.9531L22.9879 29.1371L23.1355 29.2904L24.4852 30.6918L25.8726 32.1323C26.4174 31.6076 26.7365 30.9367 26.8276 30.2408C26.9499 29.3072 26.6618 28.3287 25.9578 27.5978C25.4111 27.0301 24.7056 26.7075 23.9786 26.6325C23.7695 26.6109 23.5587 26.6099 23.3493 26.6293C23.2756 26.6361 23.2021 26.6455 23.1289 26.6575C23.0125 26.6765 22.8968 26.7019 22.7826 26.7338C22.8563 26.9053 22.8971 27.0943 22.8971 27.2927C22.8971 27.7633 22.6677 28.1804 22.3147 28.4382Z",
    fill: "#76A2D7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.931108,
    transform: "matrix(-1 0 0 1 21.4797 27.2927)",
    fill: "#76A2D7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34.1208,
    y1: 21.8521,
    x2: 42.5962,
    y2: 21.8521,
    stroke: "#76A2D7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 34.1208,
    y1: 27.0613,
    x2: 42.5962,
    y2: 27.0613,
    stroke: "#76A2D7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 34.1208,
    y1: 32.2706,
    x2: 42.5962,
    y2: 32.2706,
    stroke: "#76A2D7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooling);
export default __webpack_public_path__ + "static/media/Cooling.f823ddf36f27367afbb6ab680c0d856a.svg";
export { ForwardRef as ReactComponent };